export default "/_next/static/images/co-development-bg-c4d21c3728e5d0e9dd39f9ee93a628ea.png";